module.exports = __webpack_public_path__ + "img/PT1420.a7fceb78.png";